import * as React from "react";
import "./integration.scss";

interface IIntegrationProps {
  readonly image: string;
  readonly alt: string;
}

class Integration extends React.Component<IIntegrationProps, {}> {
  public render() {
    return (
      <div className="integration">
        <img
          className={`integration__image--${this.props.alt}`}
          src={this.props.image}
          alt={this.props.alt}
        />
        <h3 className="sr-only">{this.props.alt}</h3>
      </div>
    );
  }
}

export default Integration;



// WEBPACK FOOTER //
// ./src/components/integrations/components/integration/integration.tsx